/*
 * @Description: Description
 * @Author: Xiaohua Zhu
 * @Date: 2021-11-30 15:45:54
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-04-11 10:45:28
 */
import { LengthType, SidePlatePosition, SIDE_PLATE_TYPE } from '../utils/enum';
import { FRAMEDEPTH } from '../utils/kitchenConfig';
// import RenderBaseType from '../renderTypes/renderBaseType';
class SidePlate {
    constructor(meshManage, referenceFrameSize = null, referenceFramePosition = null) {
        this.sidePosition = null;
        this.meshManage = meshManage;
        this.referenceFrameSize = referenceFrameSize;
        this.referenceFramePosition = referenceFramePosition;
    }
    moveToPosition(position, rotation = { x: 0, y: 0, z: 0 }) {
        this.meshManage.setModelPosition(position);
        this.meshManage.addRotation(rotation.x, rotation.y, rotation.z);
        this.sidePosition = position;
    }
    /**
     * @description: 根据是否有旋转角度来改变新的侧板scaling来缩放到旧侧板的高度
     * @param {*} templateJson 完成的templateJson
     * @param {*} oldTemplatejson 老oldTemplatejson
     * @param {*} bottomChangeMap 改变的门板内容{old:[{componentBasic:xxx,relativeLocation:xxx}],new:[xxx]}
     * @param {*} topChangeMap 改变的门板内容{old:[{componentBasic:xxx,relativeLocation:xxx}],new:[xxx]}
     * @param {*} skirtingBoard 踢脚板
     * @return {*}
     * @author: Xiaohua Zhu
     */
    rollBackAfterReplace(rotation, scaling) {
        var _a, _b, _c;
        this.meshManage.mesh.scaling.y = scaling.y / ((_a = this.meshManage.getModelSize()) === null || _a === void 0 ? void 0 : _a.y);
        if (rotation.x === 0 && rotation.y === 0 && rotation.z === 0) {
            this.meshManage.mesh.scaling.x = scaling.x / ((_b = this.meshManage.getModelSize()) === null || _b === void 0 ? void 0 : _b.x);
        }
        else {
            this.meshManage.mesh.scaling.x = scaling.z / ((_c = this.meshManage.getModelSize()) === null || _c === void 0 ? void 0 : _c.z);
        }
    }
    // 摆放需要在 坐标轴x轴 上移动的侧板（length1 length3）
    lengthXSidePlateAction(basicDeviation) {
        if (this.referenceFramePosition === null) {
            return;
        }
        const { x, y, z } = this.referenceFramePosition;
        this.moveToPosition({ x: x + basicDeviation, y, z }, { x: 0, y: Math.PI / 2, z: 0 });
    }
    /**
     * 摆放需要在 坐标轴z轴 上移动的侧板 （length2 length4*）
     * 当为冰箱顶柜的侧板的时候是初始化位置的柜体处理逻辑是移动X 旋转角度
     * @param basicDeviation 侧板偏移量
     * @param type 是否为冰箱顶柜的侧板
     * @returns
     */
    lengthZSidePlateAction(basicDeviation, type = 0) {
        if (this.referenceFramePosition === null) {
            return;
        }
        const { x, y, z } = this.referenceFramePosition;
        const position = {
            x: type === SIDE_PLATE_TYPE.refrigerator ? x + basicDeviation : x,
            y,
            z: type === SIDE_PLATE_TYPE.refrigerator ? z : z + basicDeviation,
        };
        const rotation = {
            x: 0,
            y: type === SIDE_PLATE_TYPE.refrigerator ? Math.PI / 2 : 0,
            z: 0,
        };
        this.moveToPosition(position, rotation);
    }
    // 转角柜上侧板的特殊情况 通过传（顶柜/底柜）和（length）做不同的处理
    cornerSidePlateAction(basicDeviation, position, length) {
        if (this.referenceFrameSize === null || this.referenceFramePosition === null) {
            return;
        }
        let sidePlateXAfterScaling = 0;
        const { x, y, z } = this.referenceFramePosition;
        const { x: sidePlateSizeX } = this.meshManage.size;
        // 转角柜的情况特殊 需要引入FRAMEDEPTH常量来缩放侧板的长度
        // 顶柜转角柜
        if (position === SidePlatePosition.Top) {
            this.meshManage.mesh.scaling.x = FRAMEDEPTH.TOP / sidePlateSizeX;
            sidePlateXAfterScaling = sidePlateSizeX * (FRAMEDEPTH.TOP / sidePlateSizeX);
        }
        // 底柜转角柜
        if (position === SidePlatePosition.Bottom) {
            this.meshManage.mesh.scaling.x = FRAMEDEPTH.BOTTOM / sidePlateSizeX;
            sidePlateXAfterScaling = sidePlateSizeX * (FRAMEDEPTH.BOTTOM / sidePlateSizeX);
        }
        switch (length) {
            /*
              tips:
              basicDeviation 基础偏移：侧板从基准frame的中心点 移动到所要贴的位置的长度（基准模型对应长度的一半+侧板厚度的一半+补板长度）
              转角柜特殊偏移：转角柜是L型 侧板需要移动到转角柜的两头 需要水平移动到最外的位置（基准模型对应长度的一半-侧板长度的一半）
            */
            // length1 在x轴上做基础偏移 在z轴上做转角柜侧板特殊偏移
            case LengthType.Length1:
                this.moveToPosition({
                    x: x - basicDeviation,
                    y,
                    z: z - (this.referenceFrameSize.z - sidePlateXAfterScaling) / 2,
                }, { x: 0, y: Math.PI / 2, z: 0 });
                break;
            // length2 在x轴上做转角柜侧板特殊偏移 在z轴上做基础偏移
            case LengthType.Length2:
                this.moveToPosition({
                    x: x + (this.referenceFrameSize.x - sidePlateXAfterScaling) / 2,
                    y,
                    z: z + basicDeviation,
                }, { x: 0, y: 0, z: 0 });
                break;
            // length3 在x轴上做基础偏移 在z轴上做转角柜侧板特殊偏移
            case LengthType.Length3:
                this.moveToPosition({
                    x: x - basicDeviation,
                    y,
                    z: z + (this.referenceFrameSize.z - sidePlateXAfterScaling) / 2,
                }, { x: 0, y: Math.PI / 2, z: 0 });
                break;
            default:
                break;
        }
    }
    /**
    * @description: 将templateJson中的sidePlates提取出来
    * @param {TemplateJson} templateJson
    * @return {*}
    * @author: Xiaohua Zhu
    */
    static getSidePlatesAssets(templateJson) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        if ((templateJson === null || templateJson === void 0 ? void 0 : templateJson.version) && ((templateJson === null || templateJson === void 0 ? void 0 : templateJson.version) > '2.2')) {
            const sidePlatesJson = [(_b = (_a = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _a === void 0 ? void 0 : _a.length1) === null || _b === void 0 ? void 0 : _b.sidePlatesV2,
                (_d = (_c = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _c === void 0 ? void 0 : _c.length2) === null || _d === void 0 ? void 0 : _d.sidePlatesV2,
                (_f = (_e = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _e === void 0 ? void 0 : _e.length3) === null || _f === void 0 ? void 0 : _f.sidePlatesV2,
                (_h = (_g = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _g === void 0 ? void 0 : _g.length1) === null || _h === void 0 ? void 0 : _h.sidePlatesV2,
                (_k = (_j = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _j === void 0 ? void 0 : _j.length2) === null || _k === void 0 ? void 0 : _k.sidePlatesV2,
                (_m = (_l = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _l === void 0 ? void 0 : _l.length3) === null || _m === void 0 ? void 0 : _m.sidePlatesV2];
            const newSidePlatesJsonV2 = sidePlatesJson.map((i) => {
                if (i) {
                    return i.filter((j) => (j !== null)).map((k) => ({
                        componentBasic: k.componentBasic,
                    }));
                }
                return undefined;
            });
            return newSidePlatesJsonV2;
        }
        const sidePlatesJson = [(_p = (_o = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _o === void 0 ? void 0 : _o.length1) === null || _p === void 0 ? void 0 : _p.sidePlates,
            (_r = (_q = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _q === void 0 ? void 0 : _q.length2) === null || _r === void 0 ? void 0 : _r.sidePlates,
            (_t = (_s = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _s === void 0 ? void 0 : _s.length3) === null || _t === void 0 ? void 0 : _t.sidePlates,
            (_v = (_u = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _u === void 0 ? void 0 : _u.length1) === null || _v === void 0 ? void 0 : _v.sidePlates,
            (_x = (_w = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _w === void 0 ? void 0 : _w.length2) === null || _x === void 0 ? void 0 : _x.sidePlates,
            (_z = (_y = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _y === void 0 ? void 0 : _y.length3) === null || _z === void 0 ? void 0 : _z.sidePlates];
        const newSidePlatesJson = sidePlatesJson.map((i) => {
            if (i) {
                return i.filter((j) => (j !== null)).map((k) => ({
                    componentBasic: k,
                }));
            }
            return undefined;
        });
        return newSidePlatesJson;
    }
}
export default SidePlate;
